import URISanity from 'urisanity';

import windowsOpen from './useFileViewerNewLink';

export const getContenType = (fileName = '') => {
  const splitName = fileName.split('.');
  const extName = splitName[splitName.length - 1];
  const typeExtension = {
    pdf: 'application/pdf',
    image: 'image/'
  };
  const extensionImages = {
    png: 'png',
    jpg: 'jpg',
    jpeg: 'jpeg'
  };

  let typeName = typeExtension.pdf;

  if (extName in extensionImages) {
    typeName = typeExtension.image.concat(extName);
  }

  return { type: typeName };
};

export const sanitizedUrlFiles = async (link, sanityObject) => {
  const {
    allowScriptOrDataURI = false,
    allowFileSystemURI = false,
    allowCommsAppURI = false,
    allowDBConnectionStringURI = false,
    allowBrowserSpecificURI = false,
    allowWebTransportURI = false,
    allowServiceAPIURI = false
  } = sanityObject;

  const sanitizedUrl = URISanity.vet(link, {
    allowScriptOrDataURI,
    allowFileSystemURI,
    allowCommsAppURI,
    allowDBConnectionStringURI,
    allowBrowserSpecificURI,
    allowWebTransportURI,
    allowServiceAPIURI
  });

  if (sanitizedUrl) {
    windowsOpen(sanitizedUrl);
  }
};
